// extracted by mini-css-extract-plugin
export default {"Layout1":"Layout1___Jhlni","Header1":"Header1___IjyU6","Content1":"Content1___FMXYS"};